export default "__VITE_ASSET__L7858D2W__"